import api, { addBroadcastModalListener, parsePhoneNumbers } from './globalApi';
import {
  applyTranslations,
  type BroadcastI18nKey,
  subscribeLang,
  t,
} from './i18n';

// 用别名让代码更清晰
const TelegramExposedApi = api;

// ==========================================
// Simple HTML-based Modal UI
// ==========================================

let modalElement: HTMLElement | undefined = undefined;
let buttonElement: HTMLButtonElement | undefined = undefined;

function createStyles() {
  const style = document.createElement('style');
  style.textContent = `
    #exposed-modal-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      align-items: center;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }
    #exposed-modal-overlay.open {
      display: flex;
    }
    #exposed-modal {
      background: #ffffff;
      color: #333333;
      border-radius: 8px;
      width: 90%;
      max-width: 700px;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
      padding: 20px;
      padding-right: 3px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }
    #exposed-modal h2 {
      margin: 0 0 16px 0;
      font-size: 18px;
      font-weight: 600;
    }
    #exposed-modal .form-group {
      margin-bottom: 16px;
    }
    #exposed-modal label {
      display: block;
      margin-bottom: 6px;
      font-weight: 500;
      font-size: 14px;
    }
    #exposed-modal select, #exposed-modal input:not([type="checkbox"]), #exposed-modal textarea {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;
      box-sizing: border-box;
      background: #ffffff;
      color: #333333;
    }
    #exposed-modal textarea {
      min-height: 80px;
      resize: vertical;
    }
    #exposed-modal .btn-group {
      display: flex;
      gap: 10px;
      margin-top: 20px;
    }
    #exposed-modal button {
      padding: 10px 20px;
      border-radius: 4px;
      border: none;
      font-size: 14px;
      cursor: pointer;
    }
    #exposed-modal button.primary {
      background: #2481d3;
      color: white;
    }
    #exposed-modal button.secondary {
      background: #e0e0e0;
      color: #333;
    }
    #exposed-modal button.danger {
      background: #f44336;
      color: white;
    }
    #exposed-modal button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    #exposed-modal .progress-bar {
      height: 8px;
      background: #e0e0e0;
      border-radius: 4px;
      margin: 10px 0;
      overflow: hidden;
    }
    #exposed-modal .progress-fill {
      height: 100%;
      background: #2481d3;
      transition: width 0.3s ease;
    }
    #exposed-modal .checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 6px;
      max-height: 150px;
      overflow-y: auto;
      border: 1px solid #ddd;
      padding: 8px;
      border-radius: 4px;
    }
    #exposed-modal .checkbox-item {
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: 8px;
      align-items: center;
      font-size: 13px;
    }
    #exposed-modal .badge {
      display: inline-block;
      padding: 2px 6px;
      border-radius: 3px;
      font-size: 10px;
      margin-left: 6px;
    }
    #exposed-modal .badge-contact { background: #4caf50; color: white; }
    #exposed-modal .badge-group { background: #ff9800; color: white; }
    #exposed-modal .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #999;
    }
    #exposed-broadcast-button {
      position: fixed;
      top: 16px;
      right: 100px;
      z-index: 9999;
      border: none;
      color: white;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    #exposed-broadcast-button:hover {
      transform: scale(1.05);
    }
    #exposed-modal .tab-container {
      display: flex;
      border-bottom: 1px solid #ddd;
      margin-bottom: 16px;
      flex-shrink: 0;
    }
    #exposed-modal .modal-body {
      overflow-y: auto;
      flex: 1;
    }
    #exposed-modal .tab-btn {
      padding: 10px 20px;
      background: none;
      border: none;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      font-size: 14px;
      color: #666;
    }
    #exposed-modal .tab-btn.active {
      color: #2481d3;
      border-bottom-color: #2481d3;
    }
    #exposed-modal .tab-content {
      display: none;
    }
    #exposed-modal .tab-content.active {
      display: block;
    }
    #exposed-modal .scheduled-time-group {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 12px;
    }
    #exposed-modal .scheduled-time-group input[type="checkbox"] {
      width: auto;
    }
    #exposed-modal .scheduled-time-group input[type="datetime-local"] {
      flex: 1;
    }
    #exposed-modal #phone-numbers-input {
      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
      line-height: 1.5;
    }
    #exposed-modal .task-list {
      overflow-y: auto;
    }
    #exposed-modal .task-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 4px;
      margin-bottom: 8px;
    }
    #exposed-modal .task-info {
      flex: 1;
    }
    #exposed-modal .task-status {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 3px;
      font-size: 12px;
      margin-left: 8px;
    }
    #exposed-modal .task-status.pending { background: #ffc107; color: #000; }
    #exposed-modal .task-status.running { background: #2196f3; color: #fff; }
    #exposed-modal .task-status.completed { background: #4caf50; color: #fff; }
    #exposed-modal .task-status.cancelled { background: #9e9e9e; color: #fff; }
    @media (prefers-color-scheme: dark) {
      #exposed-modal {
        background: #1c1c1c;
        color: #fff;
      }
      #exposed-modal select, #exposed-modal input:not([type="checkbox"]), #exposed-modal textarea {
        background: #2c2c2c;
        color: #fff;
        border-color: #444;
      }
      #exposed-modal .progress-bar {
        background: #444;
      }
      #exposed-modal .checkbox-group {
        border-color: #444;
      }
      #exposed-modal button.secondary {
        background: #444;
        color: #fff;
      }
      #exposed-modal .tab-container {
        border-bottom-color: #444;
      }
      #exposed-modal .task-item {
        border-color: #444;
      }
    }
  `;
  document.head.appendChild(style);
}

function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;',
  }[c]!));
}

function createModal() {
  // Create overlay
  modalElement = document.createElement('div');
  modalElement.id = 'exposed-modal-overlay';

  // Create modal content
  const modal = document.createElement('div');
  modal.id = 'exposed-modal';

  modal.innerHTML = `
    <div class="tab-container">
      <button class="tab-btn active" data-tab="broadcast">📢 <span data-i18n="BroadcastTabCompose">群发消息</span></button>
      <button class="tab-btn" data-tab="schedule">📋 <span data-i18n="BroadcastTabSchedule">定时列表</span></button>
    </div>

    <div class="modal-body">
      <!-- Tab: 群发消息 -->
      <div class="tab-content active" id="tab-broadcast">
      <div class="form-group">
        <label data-i18n="BroadcastTargetModeLabel">发送对象</label>
        <select id="target-mode">
          <option value="selected" data-i18n="BroadcastTargetSelected">选择群+联系人</option>
          <option value="all_groups" data-i18n="BroadcastTargetAllGroups">所有群（排除）</option>
          <option value="all_contacts" data-i18n="BroadcastTargetAllContacts">所有联系人（排除）</option>
          <option value="group_members" data-i18n="BroadcastTargetGroupMembers">某个群的全部成员</option>
          <option value="all_chats" data-i18n="BroadcastTargetAllChats">所有联系人和群组</option>
          <option value="phone_numbers" data-i18n="BroadcastTargetPhoneNumbers">手机号码</option>
        </select>
      </div>
      <div class="form-group" id="selected-chats-group">
        <label data-i18n="BroadcastSelectedChatsLabel">选择聊天</label>
        <div class="checkbox-group" id="chats-list"></div>
      </div>
      <div class="form-group" id="exclude-group" style="display:none;">
        <label data-i18n="BroadcastExcludeLabel">排除的聊天</label>
        <div class="checkbox-group" id="exclude-list"></div>
      </div>
      <div class="form-group" id="group-select-group" style="display:none;">
        <label data-i18n="BroadcastGroupSelectLabel">选择群</label>
        <select id="group-select"></select>
      </div>
      <div class="form-group" id="phone-numbers-group" style="display:none;">
        <label data-i18n="BroadcastPhoneLabel">手机号码（空格 / 换行 / 逗号分隔，最多 100 个）</label>
        <textarea
          id="phone-numbers-input"
          rows="4"
          data-i18n-placeholder="BroadcastPhonePlaceholder"
          placeholder="例如：85259845194 8613800000000"
        ></textarea>
        <div
          id="phone-numbers-hint"
          style="font-size:12px; color:#999; margin-top:4px;"
          data-i18n="BroadcastPhoneHint"
          data-i18n-vars='{"count":0,"max":100}'
        >0 / 100</div>
      </div>
      <div class="form-group">
        <label data-i18n="BroadcastContentTypeLabel">消息类型</label>
        <select id="content-type">
          <option value="text" data-i18n="BroadcastContentText">文本消息</option>
          <option value="media" data-i18n="BroadcastContentMedia">媒体文件</option>
          <option value="image_text" data-i18n="BroadcastContentImageText">图片+文本</option>
        </select>
      </div>
      <div class="form-group" id="text-content-group">
        <label data-i18n="BroadcastMessageLabel">消息内容</label>
        <textarea
          id="message-text"
          data-i18n-placeholder="BroadcastMessagePlaceholder"
          placeholder="输入要发送的文本..."
        ></textarea>
      </div>
      <div class="form-group" id="media-content-group" style="display:none;">
        <label data-i18n="BroadcastMediaLabel">选择文件</label>
        <input type="file" id="media-files" multiple accept="image/*,video/*,audio/*">
      </div>
      <div class="form-group" id="image-text-content-group" style="display:none;">
        <label data-i18n="BroadcastImageTextImageLabel">选择图片</label>
        <input type="file" id="image-text-file" accept="image/*">
        <label style="margin-top:10px; display:block;" data-i18n="BroadcastImageTextMessageLabel">图片下方文字</label>
        <textarea
          id="image-text-message"
          data-i18n-placeholder="BroadcastImageTextMessagePlaceholder"
          placeholder="输入图片下方的文字内容..."
        ></textarea>
      </div>
      <div class="form-group">
        <label data-i18n="BroadcastIntervalLabel">发送间隔（秒）</label>
        <div style="display:flex; gap:10px; align-items:center;">
          <input type="number" id="interval-min" value="10" min="3" max="200" style="width:80px;">
          <span data-i18n="BroadcastIntervalSep">~</span>
          <input type="number" id="interval-max" value="20" min="3" max="200" style="width:80px;">
        </div>
      </div>
      <div class="form-group scheduled-time-group">
        <input type="checkbox" id="is-scheduled">
        <label style="margin:0;" data-i18n="BroadcastScheduleLabel">定时发送</label>
        <input type="datetime-local" id="scheduled-time" step="1" disabled>
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" id="is-silent"> <span data-i18n="BroadcastSilentLabel">静默发送（不提醒）</span>
        </label>
      </div>
      <div class="form-group" id="progress-group" style="display:none;">
        <label data-i18n="BroadcastProgressLabel">发送进度</label>
        <div class="progress-bar">
          <div class="progress-fill" id="progress-fill" style="width:0%"></div>
        </div>
        <div
          id="progress-text"
          data-i18n="BroadcastProgressDetail"
          data-i18n-vars='{"current":0,"total":0,"percent":0,"success":0,"fail":0}'
        >0 / 0 (0%)</div>
      </div>
      <div class="btn-group">
        <button class="primary" id="btn-start" data-i18n="BroadcastBtnStart">开始群发</button>
        <button class="secondary" id="btn-cancel" style="display:none;" data-i18n="BroadcastBtnStop">停止发送</button>
        <button class="secondary" id="btn-close" data-i18n="BroadcastBtnClose">关闭</button>
      </div>
    </div>

    <!-- Tab: 定时列表 -->
    <div class="tab-content" id="tab-schedule">
      <div class="task-list" id="task-list" style="height: 62.5vh;">
        <div
          id="task-empty-placeholder"
          style="text-align:center; color:#999; padding:20px;"
          data-i18n="BroadcastTaskEmpty"
        >暂无定时任务</div>
      </div>
      <div class="btn-group">
        <button class="secondary btn-refresh" data-i18n="BroadcastBtnRefresh">刷新列表</button>
        <button class="secondary btn-close-schedule" data-i18n="BroadcastBtnClose">关闭</button>
      </div>
    </div>
    </div>
  `;

  modalElement.appendChild(modal);

  // Add close button
  const closeBtn = document.createElement('button');
  closeBtn.className = 'close-btn';
  closeBtn.innerHTML = '×';
  closeBtn.onclick = () => closeModal();
  modal.appendChild(closeBtn);

  document.body.appendChild(modalElement);

  // Event listeners
  const targetMode = document.getElementById('target-mode') as HTMLSelectElement;
  const contentType = document.getElementById('content-type') as HTMLSelectElement;
  const btnStart = document.getElementById('btn-start') as HTMLButtonElement;
  const btnCancel = document.getElementById('btn-cancel') as HTMLButtonElement;
  const btnClose = document.getElementById('btn-close') as HTMLButtonElement;
  const progressGroup = document.getElementById('progress-group') as HTMLDivElement;
  const progressFill = document.getElementById('progress-fill') as HTMLDivElement;
  const progressText = document.getElementById('progress-text') as HTMLDivElement;

  // Tab switching
  const tabBtns = modal.querySelectorAll('.tab-btn');
  const tabContents = modal.querySelectorAll('.tab-content');
  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabId = (btn as HTMLButtonElement).dataset.tab;
      tabBtns.forEach((b) => b.classList.remove('active'));
      tabContents.forEach((c) => c.classList.remove('active'));
      (btn as HTMLButtonElement).classList.add('active');
      document.getElementById(`tab-${tabId}`)?.classList.add('active');
      // 切换到定时列表时刷新
      if (tabId === 'schedule') {
        refreshTaskList();
      }
    });
  });

  // Refresh task list
  function refreshTaskList() {
    const taskList = document.getElementById('task-list') as HTMLDivElement;
    const tasks = TelegramExposedApi.getBroadcastTasks() as Array<{
      id: number;
      status: string;
      progress: { current: number; total: number };
      scheduledTime?: number;
      targetMode: string;
      targetCount: number;
      contentType: string;
      contentPreview: string;
    }>;

    if (tasks.length === 0) {
      taskList.innerHTML = `<div style="text-align:center; color:#999; padding:20px;">
        ${escapeHtml(t('BroadcastTaskEmpty'))}
      </div>`;
      return;
    }

    taskList.innerHTML = tasks.map((task) => {
      const statusKey = (`BroadcastTaskStatus${
        task.status.charAt(0).toUpperCase()}${task.status.slice(1)
      }`) as BroadcastI18nKey;
      const statusText = t(statusKey);

      let timeInfo = '';
      if (task.scheduledTime) {
        const date = new Date(task.scheduledTime);
        const scheduledLabel = t('BroadcastTaskScheduledTime', { time: date.toLocaleString() });
        timeInfo = `<div style="font-size:12px; color:#666;">${escapeHtml(scheduledLabel)}</div>`;
      }

      // 目标信息
      const targetInfo = task.targetCount > 0
        ? `<div style="font-size:12px; color:#666;">${
          escapeHtml(t('BroadcastTaskTargetWithCount', { mode: task.targetMode, count: task.targetCount }))
        }</div>`
        : `<div style="font-size:12px; color:#666;">${
          escapeHtml(t('BroadcastTaskTargetNoCount', { mode: task.targetMode }))
        }</div>`;

      // 内容预览
      const contentInfo = `<div style="font-size:12px; color:#666;">
        ${escapeHtml(t('BroadcastTaskContent', { type: task.contentType, preview: task.contentPreview }))}
      </div>`;

      const canCancel = task.status === 'pending' || task.status === 'running';
      const cancelText = escapeHtml(t('BroadcastBtnCancel'));
      // Use data-task-id so each cancel button knows its own id.
      // Delegated click handler below is bound once per refresh, not per task,
      // so we no longer rely on a single global __cancelTask that would be
      // overwritten by every task in the loop.
      const cancelBtn = canCancel
        ? `<button class="danger btn-cancel-task" style="padding:5px 10px; font-size:12px;"
          data-task-id="${task.id}">${cancelText}</button>`
        : '';

      return `
        <div class="task-item">
          <div class="task-info">
            <div>
              ${escapeHtml(t('BroadcastTaskTitle', { id: task.id }))}
              <span class="task-status ${task.status}">${escapeHtml(statusText)}</span>
            </div>
            <div style="font-size:12px; color:#666;">${
              escapeHtml(t('BroadcastTaskProgress', { current: task.progress.current, total: task.progress.total }))
            }</div>
            ${targetInfo}
            ${contentInfo}
            ${timeInfo}
          </div>
          ${cancelBtn}
        </div>
      `;
    }).join('');
  }

  // 事件委托：所有取消按钮共用一个 click handler，从 data-task-id 取正确的 id。
  async function handleCancelClick(e: Event) {
    const target = e.target as HTMLButtonElement | null;
    if (!target || !target.classList.contains('btn-cancel-task')) return;
    const taskId = Number(target.dataset.taskId);
    if (!taskId) return;
    target.disabled = true;
    try {
      await TelegramExposedApi.cancelBroadcast(taskId);
    } finally {
      refreshTaskList();
    }
  }

  // 将取消事件委托到 task-list（只在打开时绑定一次）
  const taskListEl = document.getElementById('task-list') as HTMLDivElement;
  taskListEl.addEventListener('click', handleCancelClick);

  // 定时列表"刷新/关闭"按钮的点击事件委托（与取消按钮同模式，避免同类隐患）
  function handleScheduleTabClick(e: Event) {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    if (target.classList.contains('btn-refresh')) {
      refreshTaskList();
      return;
    }
    if (target.classList.contains('btn-close-schedule')) {
      closeModal();
    }
  }

  // 定时发送复选框
  const isScheduled = document.getElementById('is-scheduled') as HTMLInputElement;
  const scheduledTimeInput = document.getElementById('scheduled-time') as HTMLInputElement;

  // 设置默认时间为当前时间（精确到秒）
  function setDefaultScheduledTime() {
    const now = new Date();
    // 默认值置为当前时间
    now.setMinutes(now.getMinutes());

    // 使用本地时区格式
    const pad = (n: number) => n.toString().padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());
    const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    scheduledTimeInput.value = localDateTime;
  }

  isScheduled.addEventListener('change', () => {
    scheduledTimeInput.disabled = !isScheduled.checked;
    if (isScheduled.checked && !scheduledTimeInput.value) {
      setDefaultScheduledTime();
    }
  });

  // 点击时间选择器时，显示当前时间作为默认值
  scheduledTimeInput.addEventListener('click', () => {
    if (!scheduledTimeInput.value) {
      setDefaultScheduledTime();
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let isRunning = false;
  let currentTaskId: number | undefined = undefined;

  // Show/hide fields based on target mode
  targetMode.onchange = () => {
    const mode = targetMode.value;
    const selectedChatsGroup = document.getElementById('selected-chats-group') as HTMLDivElement;
    const excludeGroup = document.getElementById('exclude-group') as HTMLDivElement;
    const groupSelectGroup = document.getElementById('group-select-group') as HTMLDivElement;
    const phoneNumbersGroup = document.getElementById('phone-numbers-group') as HTMLDivElement;
    selectedChatsGroup.style.display = mode === 'selected' ? 'block' : 'none';
    excludeGroup.style.display = ['all_groups', 'all_contacts', 'all_chats'].includes(mode) ? 'block' : 'none';
    groupSelectGroup.style.display = mode === 'group_members' ? 'block' : 'none';
    phoneNumbersGroup.style.display = mode === 'phone_numbers' ? 'block' : 'none';
    loadChatsOrGroups();
  };

  // 手机号输入实时计数（用于 UI 提示，不影响提交逻辑）
  const phoneNumbersInput = document.getElementById('phone-numbers-input') as HTMLTextAreaElement;
  const phoneNumbersHint = document.getElementById('phone-numbers-hint') as HTMLDivElement;
  const updatePhoneNumbersHint = () => {
    const count = phoneNumbersInput.value.trim().split(/[\s\n,，]+/).filter(Boolean).length;
    const shown = Math.min(count, 100);
    phoneNumbersHint.textContent = t('BroadcastPhoneHint', { count: shown, max: 100 });
    phoneNumbersHint.style.color = count > 100 ? '#f44336' : '#999';
  };
  phoneNumbersInput.addEventListener('input', updatePhoneNumbersHint);
  updatePhoneNumbersHint();

  // Show/hide content fields
  contentType.onchange = () => {
    const type = contentType.value;
    const textContentGroup = document.getElementById('text-content-group') as HTMLDivElement;
    const mediaContentGroup = document.getElementById('media-content-group') as HTMLDivElement;
    const imageTextContentGroup = document.getElementById('image-text-content-group') as HTMLDivElement;
    textContentGroup.style.display = type === 'text' ? 'block' : 'none';
    mediaContentGroup.style.display = type === 'media' ? 'block' : 'none';
    imageTextContentGroup.style.display = type === 'image_text' ? 'block' : 'none';
  };

  // Load chats or groups
  function loadChatsOrGroups() {
    const mode = targetMode.value;
    const chatsList = document.getElementById('chats-list') as HTMLDivElement;
    const groupSelect = document.getElementById('group-select') as HTMLSelectElement;

    if (mode === 'selected') {
      const chats = TelegramExposedApi.getAvailableChats() as Array<{
        id: string; title: string; type: string; isContact?: boolean;
      }>;
      chatsList.innerHTML = chats.map((chat) => `
        <label class="checkbox-item">
          <input type="checkbox" value="${chat.id}">
          ${escapeHtml(chat.title)}
          ${chat.isContact ? `<span class="badge badge-contact">${
            escapeHtml(t('BroadcastBadgeContact'))
          }</span>` : ''}
          ${chat.type === 'group' ? `<span class="badge badge-group">${
            escapeHtml(t('BroadcastBadgeGroup'))
          }</span>` : ''}
        </label>
      `).join('');
    } else if (mode === 'group_members') {
      type GroupItem = { id: string; title: string; membersCount?: number };
      const groups = TelegramExposedApi.getAllGroups() as GroupItem[];
      groupSelect.innerHTML = `<option value="">${t('BroadcastGroupSelectPlaceholder')}</option>` +
        groups.map((g) => `<option value="${g.id}">${
          escapeHtml(g.title)
        } (${g.membersCount || 0} ${t('BroadcastMembersUnit')})</option>`).join('');
    }

    // 加载排除列表（复选框形式）
    if (['all_groups', 'all_contacts', 'all_chats'].includes(mode)) {
      const excludeList = document.getElementById('exclude-list') as HTMLDivElement;

      let items: Array<{ id: string; title: string; type?: string }> = [];

      if (mode === 'all_groups') {
        // 排除群
        items = TelegramExposedApi.getAllGroups() as Array<{ id: string; title: string }>;
      } else if (mode === 'all_contacts') {
        // 排除联系人
        items = TelegramExposedApi.getAllContacts() as Array<{ id: string; title: string }>;
      } else if (mode === 'all_chats') {
        // 排除所有聊天（群 + 联系人）
        type ChatItem = { id: string; title: string; type?: string };
        const groups = TelegramExposedApi.getAllGroups() as ChatItem[];
        const contacts = TelegramExposedApi.getAllContacts() as ChatItem[];
        items = [...groups, ...contacts];
      }

      excludeList.innerHTML = items.map((item) => `
        <label class="checkbox-item">
          <input type="checkbox" value="${item.id}">
          ${escapeHtml(item.title)}
          ${item.type === 'group' ? `<span class="badge badge-group">${
            escapeHtml(t('BroadcastBadgeGroup'))
          }</span>` : ''}
        </label>
      `).join('');
    }
  }

  // Start broadcast
  btnStart.onclick = async () => {
    const mode = targetMode.value;
    const type = contentType.value;
    let intervalMin = parseInt((document.getElementById('interval-min') as HTMLInputElement).value, 10);
    let intervalMax = parseInt((document.getElementById('interval-max') as HTMLInputElement).value, 10);

    // 验证 interval，最小为 1 秒，最大为 200 秒
    if (intervalMin < 1) {
      intervalMin = 1;
      // 更新 UI 显示
      (document.getElementById('interval-min') as HTMLInputElement).value = '1';
    }
    if (intervalMax < intervalMin) {
      intervalMax = intervalMin;
      // 更新 UI 显示
      (document.getElementById('interval-max') as HTMLInputElement).value = String(intervalMax);
    }
    if (intervalMax > 200) {
      intervalMax = 200;
      // 更新 UI 显示
      (document.getElementById('interval-max') as HTMLInputElement).value = '200';
    }

    const isSilent = (document.getElementById('is-silent') as HTMLInputElement).checked;

    // Build target
    const target: any = { mode };
    if (mode === 'selected') {
      const checkboxes = document.querySelectorAll('#chats-list input:checked');
      target.chatIds = Array.from(checkboxes).map((cb) => (cb as HTMLInputElement).value);
      if (target.chatIds.length === 0) {
        alert(t('BroadcastAlertPickChat'));
        return;
      }
    } else if (['all_groups', 'all_contacts', 'all_chats'].includes(mode)) {
      // 获取排除的群 ID（复选框列表）
      const excludeList = document.getElementById('exclude-list') as HTMLDivElement;
      const checkboxes = excludeList.querySelectorAll('input[type="checkbox"]:checked');
      target.excludeChatIds = Array.from(checkboxes).map((cb) => (cb as HTMLInputElement).value);
    } else if (mode === 'group_members') {
      const groupId = (document.getElementById('group-select') as HTMLSelectElement).value;
      if (!groupId) {
        alert(t('BroadcastAlertPickGroup'));
        return;
      }
      target.fromGroupId = groupId;
    } else if (mode === 'phone_numbers') {
      const raw = (document.getElementById('phone-numbers-input') as HTMLTextAreaElement).value;
      const phones = parsePhoneNumbers(raw);
      if (phones.length === 0) {
        alert(t('BroadcastAlertPickPhone'));
        return;
      }
      // 把解析结果回填到 UI，给用户确认；同时存原始字符串到 target 用于持久化
      (document.getElementById('phone-numbers-input') as HTMLTextAreaElement).value = phones.join(' ');
      target.phoneNumbers = phones.join(' ');
    }

    // Build content
    let content: any;
    if (type === 'text') {
      const text = (document.getElementById('message-text') as HTMLTextAreaElement).value;
      if (!text.trim()) {
        alert(t('BroadcastAlertPickMessage'));
        return;
      }
      content = { type: 'text', text };
    } else if (type === 'media') {
      const fileInput = document.getElementById('media-files') as HTMLInputElement;
      if (!fileInput.files || fileInput.files.length === 0) {
        alert(t('BroadcastAlertPickFile'));
        return;
      }
      const files = Array.from(fileInput.files).map((file) => ({ file, filename: file.name }));
      content = { type: 'media', files };
    } else {
      const fileInput = document.getElementById('image-text-file') as HTMLInputElement;
      const text = (document.getElementById('image-text-message') as HTMLTextAreaElement).value;
      if (!fileInput.files || fileInput.files.length === 0) {
        alert(t('BroadcastAlertPickImage'));
        return;
      }
      if (!text.trim()) {
        alert(t('BroadcastAlertPickImageText'));
        return;
      }
      const imageFile = fileInput.files[0];
      content = { type: 'image_text', file: { file: imageFile, filename: imageFile.name }, text };
    }

    // Start broadcast
    // 获取定时发送时间
    let startAt: Date | undefined;
    if (isScheduled.checked) {
      const scheduledValue = scheduledTimeInput.value;
      if (scheduledValue) {
        startAt = new Date(scheduledValue);
        if (startAt.getTime() <= Date.now()) {
          alert(t('BroadcastAlertTimeMustFuture'));
          return;
        }
      }
    }

    const sendResult = await TelegramExposedApi.scheduleBroadcast({
      target,
      content,
      interval: { minMs: intervalMin * 1000, maxMs: intervalMax * 1000 },
      isSilent,
      startAt,
      onProgress: (current, total, chatId, result) => {
        // 累积成功/失败计数
        const successCount = progressFill.dataset.successCount
          ? Number(progressFill.dataset.successCount) : 0;
        const failCount = progressFill.dataset.failCount
          ? Number(progressFill.dataset.failCount) : 0;
        if (result && result.ok) {
          progressFill.dataset.successCount = String(successCount + 1);
        } else {
          progressFill.dataset.failCount = String(failCount + 1);
        }
        const newSuccess = progressFill.dataset.successCount ? Number(progressFill.dataset.successCount) : 0;
        const newFail = progressFill.dataset.failCount ? Number(progressFill.dataset.failCount) : 0;

        const percent = Math.round((current / total) * 100);
        progressFill.style.width = `${percent}%`;
        progressText.textContent = t('BroadcastProgressDetail', {
          current, total, percent, success: newSuccess, fail: newFail,
        });

        // 单条失败即时提示，方便用户诊断
        if (result && !result.ok && result.reason !== 'chat_not_found') {
          // eslint-disable-next-line no-console
          console.warn('[broadcast] send failed:', chatId, result);
        }

        // 检查完成
        if (total > 0 && current >= total) {
          isRunning = false;
          btnStart.style.display = 'inline-block';
          btnCancel.style.display = 'none';
          if (newFail > 0 && newSuccess === 0) {
            alert(t('BroadcastFinishedAllFail', { fail: newFail }));
          } else if (newFail > 0) {
            alert(t('BroadcastFinishedPartial', { success: newSuccess, fail: newFail }));
          } else {
            alert(t('BroadcastFinishedAllOk', { success: newSuccess }));
          }
          // 自动刷新列表
          refreshTaskList();
        }
      },
    });

    if (sendResult.ok) {
      if (startAt) {
        // 定时发送
        alert(t('BroadcastScheduledCreated', { time: startAt.toLocaleString() }));
        // 切换到定时列表
        tabBtns.forEach((b) => b.classList.remove('active'));
        tabContents.forEach((c) => c.classList.remove('active'));
        (tabBtns[1] as HTMLButtonElement).classList.add('active');
        document.getElementById('tab-schedule')?.classList.add('active');
        refreshTaskList();
      } else {
        // 立即发送
        isRunning = true;
        currentTaskId = sendResult.taskId;
        btnStart.style.display = 'none';
        btnCancel.style.display = 'inline-block';
        progressGroup.style.display = 'block';
      }
    }
  };

  // Cancel broadcast
  btnCancel.onclick = async () => {
    if (currentTaskId) {
      await TelegramExposedApi.cancelBroadcast(currentTaskId);
      isRunning = false;
      currentTaskId = undefined;
      btnStart.style.display = 'inline-block';
      btnCancel.style.display = 'none';
    }
  };

  // Close modal
  btnClose.onclick = () => closeModal();

  // 定时列表按钮（刷新 / 关闭）统一改用事件委托，避免类似取消按钮 onclick 被覆盖的隐患
  modalElement.addEventListener('click', handleScheduleTabClick);

  modalElement.onclick = (e) => {
    if (e.target === modalElement) closeModal();
  };

  // i18n: 把当前语言的文案一次性灌进整个模态框，并订阅以便运行时切换语言后整面板刷新
  // 注意：`modalElement` 是全局 let，TS 推断为 HTMLElement | undefined；
  // 此处 createModal() 已赋值，用非空断言即可（与 openModal 中同样的处理方式）
  const modalRoot = modalElement;
  applyTranslations(modalRoot);
  subscribeLang(() => {
    applyTranslations(modalRoot);
    // 任务列表的"无任务"占位 div 是 JS 动态生成的，applyTranslations 不会扫到；这里手动刷一次即可
    refreshTaskList();
  });

  // Initial load
  loadChatsOrGroups();
}

function openModal() {
  if (!modalElement) {
    createModal();
  }
  // 使用 style.display 避免触发 React stricterdom 检测
  (modalElement as HTMLElement).style.display = 'flex';
}

function closeModal() {
  // 使用 style.display 避免触发 React stricterdom 检测
  if (modalElement) {
    (modalElement).style.display = 'none';
  }
}

// Create the floating button
function createButton() {
  buttonElement = document.createElement('button');
  buttonElement.id = 'exposed-broadcast-button';
  buttonElement.innerHTML = '📢';
  buttonElement.title = t('BroadcastOpenPanelTitle');
  buttonElement.onclick = () => openModal();
  document.body.appendChild(buttonElement);
}

// Initialize
function init() {
  // Avoid duplicate initialization
  if (buttonElement) return;

  createStyles();
  // 添加群发按钮
  createButton();

  // Listen to API events
  addBroadcastModalListener((isOpen) => {
    if (isOpen) {
      openModal();
    } else {
      closeModal();
    }
  });
}

init();
